import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        cardContainer: {
            cursor: 'pointer',
            flexDir: 'column',
            width: '100%',
        },
        imgWrapper: {
            position: 'relative',
            marginBottom: {base: remCalc(12), lg: remCalc(32)},
        },
        gridCardOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'unset',
        },
        tileImage: {maxH: '100%'},
        cardText: {
            textStyle: 'head-xsmall',
            fontWeight: 'medium',
            color: 'text.default',
        },
    },
    variants: {
        manuals: {
            cardContainer: {
                maxW: remCalc(332),
                paddingY: {base: 'xsmall.base'},
                paddingX: {base: 0, lg: 'xsmall.base'},
            },
            gridCardOverlay: {
                backgroundColor: 'rgba(0,0,0,0.2)',
                opacity: 0,
                transition: 'opacity 0.2s',
                pointerEvents: 'none',
                _groupHover: {opacity: {base: 0, lg: 1}},
                _hover: {
                    backgroundColor: 'rgba(0,0,0,0.2)',
                },
                height: '100%',
            },
            tileImage: {
                maxH: remCalc(230),
                width: '100%',
                objectFit: 'cover',
                display: 'block',
            },
        },
        faqs: {
            tileImage: {
                width: '100%',
                height: '100%',
                minHeight: '100%',
                maxWidth: remCalc(332),
                maxHeight: remCalc(230),
                overflow: 'hidden',
                mixBlendMode: 'multiply',
            },
            gridCardOverlay: {
                backgroundColor: 'background.image',
                display: 'flex',
                flexDir: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'background.image',
            },
            cardContainer: {
                maxWidth: remCalc(332),
                height: '100%',
                m: '0 auto',
                justifyContent: 'flex-start',
                textAlign: 'left',
            },
            imgWrapper: {
                _hover: {
                    bgImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%)`,
                    bgPosition: '50%',
                    bgSize: 'contain',
                    bgRepeat: 'no-repeat',
                    bgBlendMode: 'normal, multiply, normal',
                    bgColor: 'background.light-dark',
                },
                _focus: {
                    bgImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%)`,
                    bgPosition: '50%',
                    bgSize: 'contain',
                    bgRepeat: 'no-repeat',
                    bgBlendMode: 'normal, multiply, normal',
                    bgColor: 'background.light-dark',
                },
            },
        },
    },
    parts: ['cardContainer', 'tileImage', 'cardText', 'gridCardOverlay', 'imgWrapper'],
}
